import $ from 'jquery'
import nav from 'hotwire/nav'
import pusherStreams from 'hotwire/pusherStreams'
import {setupAsyncRolePersonDropdown} from './async_dropdown'

function animate(divId, animation) {
  const div = $(divId)
  const clear = () => { div.slideUp() }
  switch (animation) {
    case 'remain-left':
      div.css({position: 'relative'})
      div.animate({left: '-=100%'}, 500)
      break
    case 'slide-left':
      div.css({position: 'relative'})
      div.animate({left: '-=100%'}, 500, clear)
      break
    case 'slide-right':
      div.css({position: 'relative'})
      div.animate({left: '+=100%'}, 500, clear)
      break
    case 'slide-up':
      div.slideUp()
      break
    default:
      // Placate the linter
  }
}

function closeBsModal() {
  // Attempt to close the modal properly
  $('.modal-dialog .close').click()

  // Clean up artifacts from any potential failure
  $('.modal').modal('hide')
  $('.modal-backdrop').remove()
  $('body').removeClass('modal-open')
}

function enableBsPopovers(container) {
  $('[data-toggle="popover"]').popover({
    container,
    html: true,
    placement: 'bottom',
    trigger: 'click focus hover',
  })
}

function enableFrogboxes(organizationId) {
  $('.hotwired-frogbox-toggle').on('click', (event) => {
    const frogbox = $(event.target).closest('.hotwired-frogbox-toggle').data('frogbox')
    const turboframe = document.getElementById(`frogbox-${frogbox}`)

    if (turboframe.childElementCount > 0)
      turboframe.innerHTML = ''
    else
      turboframe.setAttribute('src', `/organizations/${organizationId}/dialogs/frogbox/${frogbox}`)
  })
}

function enableReordering(containerId, reorderPath) {
  $(containerId).sortable({
    forcePlaceholderSize: true,
    handle: '.js-sorting-handle',
    items: '> turbo-frame',
    placeholder: 'sortable-placeholder',
    update: (event) => {
      $.ajax({
        data: $(event.target).sortable('serialize'),
        type: 'PUT',
        url: reorderPath,
      })
    },
  })
}

function refreshTurboFrame(frameID, src = null) {
  const turboFrame = document.getElementById(frameID)
  if (turboFrame) {
    if (src)
      turboFrame.src = src
    turboFrame.reload()
  }
}

function setModified(event) {
  const $form = $(event.target).closest('form')
  $form.data('modified', true)
}

function queueSubmit(event, timeout = 30) {
  const $form = $(event.target).closest('form')
  const queuedFn = setTimeout(() => {
    if ($form.data('modified'))
      $form[0].requestSubmit()
  }, timeout)
  $form.data('timeout', queuedFn)
}

function dequeueSubmit(event) {
  const $form = $(event.target).closest('form')
  window.clearTimeout($form.data('timeout'))
  $form.data('timeout', null)
}

function setupSlickForms() {
  // debug...
  setTimeout(() => {
    $('body').on(
      'change',
      'form.slick-form input, form.slick-form textarea, form.slick-form select,'
      + 'form.slick-form .js-slick-role-select, form.slick-form .js-slick-person-select',
      setModified,
    )

    $('body').on(
      'blur',
      'form.slick-form input, form.slick-form textarea, form.slick-form select',
      queueSubmit,
    )
    $('body').on(
      'focus',
      'form.slick-form input, form.slick-form textarea, form.slick-form select',
      dequeueSubmit,
    )

    // Setup the role-person dropdown relationship handlers
    setupAsyncRolePersonDropdown()
  }, 100)
}

export default
{animate,
  closeBsModal,
  enableBsPopovers,
  enableFrogboxes,
  enableReordering,
  nav,
  pusherStreams,
  refreshTurboFrame,
  setupSlickForms}
